import { ProFormGroup } from '@ant-design/pro-components'
import { useLingui } from '@lingui/react/macro'
import { useFieldContext, useFormContext } from '@pkg/form/createAppFormHook'
import { joinNames } from '@pkg/form/utils/form.utils'

export interface ValidPeriodGroup {
  activeFrom?: string | null
  activeTo?: string | null
  createdAt?: string | null
}

export type ValidPeriodGroupFieldProps = {
  className?: string
  includeCreatedAt?: boolean
  onActiveFromChange?: (val: string | null) => void
  onActiveToChange?: (val: string | null) => void
}

export function ValidPeriodGroupField(props: ValidPeriodGroupFieldProps) {
  const { className, includeCreatedAt, onActiveFromChange, onActiveToChange } = props
  const field = useFieldContext<ValidPeriodGroup>()
  const form = useFormContext()
  const { t } = useLingui()

  return (
    <ProFormGroup title={false} rowProps={{ gutter: [16, 0] }} className={className}>
      {includeCreatedAt && (
        <form.AppField name={joinNames(field, 'createdAt')}>
          {field => (
            <field.DatePicker readonly label={t`Erstellt am`} colProps={{ md: includeCreatedAt ? 8 : 12, xs: 24 }} />
          )}
        </form.AppField>
      )}
      <form.AppField
        name={joinNames(field, 'activeFrom')}
        listeners={{
          onChange: onActiveFromChange ? e => onActiveFromChange(e.value as string) : undefined,
        }}
      >
        {field => <field.DatePicker label={t`gültig von`} colProps={{ md: includeCreatedAt ? 8 : 12, xs: 24 }} />}
      </form.AppField>
      <form.AppField
        name={joinNames(field, 'activeTo')}
        listeners={{
          onChange: onActiveToChange ? e => onActiveToChange(e.value as string) : undefined,
        }}
      >
        {field => <field.DatePicker label={t`gültig bis`} colProps={{ md: includeCreatedAt ? 8 : 12, xs: 24 }} />}
      </form.AppField>
    </ProFormGroup>
  )
}
